import React, { Component } from 'react';
import { Button, IconButton, Table, TableCell, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
// import TableHead from '@material-ui/core/TableHead';
const styles = (theme) => ({
  dialogRoot: {},
  dialogTitle: {
    margin: '0',
    padding: '8px 8px 0',
    fontSize: '20px',
    color: theme.palette.primary.main,
  },
  dialogTitleContent: {
    fontWeight: 'bold',
    margin: '0 15px',
    paddingTop: '1em',
    paddingBottom: '1.5em',
    borderBottom: `2px solid #d5d5d5`,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  dialogContent: {
    marginBottom: '10px',
  },
  dialogActions: {
    borderTop: '1px solid #ebebeb',
    margin: '0 24px',
    textAlign: 'center',
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  contents: {
    padding: theme.spacing(1),
  },
  msgImg: {
    width: '100%',
    height: 'auto',
  },
  tableHead: {
    background: '#f3f3f3',
    width: '160px',
    borderTop: '1px solid #e0e0e0',
    borderLeftWidth: '0px',
    borderRightWidth: '0px',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableContent: {
    borderLeftWidth: '0px',
    borderRightWidth: '0px',
    width: '20%',
    marginRight: '2px',
  },
});

class ProgramDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes, open, onClose, disableBackdrop, selectedIndex, satellitesData } = this.props;
    const data = satellitesData[selectedIndex];

    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'md'}
          onClose={onClose}
          aria-labelledby="welcome-msg-dia log"
          open={open}
          disableBackdropClick={disableBackdrop}
          disableEscapeKeyDown={disableBackdrop}
          className={classes.dialogRoot}
        >
          <DialogTitle className={classes.dialogTitle}>
            {data ? <div className={classes.dialogTitleContent}>Satellite Session - {data.name}</div> : ''}
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <Table>
              <TableBody>
                {data &&
                  data.program.map((pgm, idx) => {
                    const pre = pgm.presenter ? pgm.presenter.split('^') : [pgm.presenter];
                    if (idx === 0) {
                      return (
                        <React.Fragment key={idx}>
                          <TableRow style={{ backgroundColor: 'rgba(20, 180, 179, 0.25)' }}>
                            <TableCell rowSpan={2} style={{ fontWeight: 'bold' }}>
                              {pgm.title}
                            </TableCell>
                            <TableCell align="right" style={{ borderBottom: '0px' }} padding={'normal'}>
                              {pre[0]}
                            </TableCell>
                          </TableRow>
                          <TableRow key={idx + '_0'} style={{ backgroundColor: 'rgba(20, 180, 179, 0.25)' }}>
                            <TableCell align="right" padding={'normal'}>
                              {pre[1]}
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    } else {
                      return (
                        <TableRow key={idx}>
                          <TableCell>{pgm.title}</TableCell>
                          <TableCell align="right">{pre[0]}</TableCell>
                        </TableRow>
                      );
                    }
                  })}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={onClose} style={{ color: '#000000', fontSize: '18px', fontWeight: '600' }}>
              {/* 닫기 */} Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ProgramDialog);
